// extracted by mini-css-extract-plugin
export default {"tr":"style_tr__DCQ0t","td":"style_td__PBLsb","binIcon":"style_binIcon__3A6hB","minusIcon":"style_minusIcon__qr4PR","plusIcon":"style_plusIcon__ZNNOd"};